import $$ from 'cmn-utils';

/** 
 * 用户机构所在默认文件夹id
 */
const getUserFolderId = () => {
  if ($$.getStore("user") && $$.getStore("user").org && $$.getStore("user").org.folder) {
    return $$.getStore("user").org.folder.id;
  }
  return "-1";
}

/** 
 * 用户机构所在默认文件夹id
 */
const getUserOrgId = () => {
  if ($$.getStore("user") && $$.getStore("user").org) {
    return $$.getStore("user").org.id;
  }
  return "-1";
}


/** 
 * 将分散的node，拼装成树 
 * 返回集合:{ 素材类型:文件夹数据 }
 */
const createTreeNodes = (nodeList, keyArr) => {
  //未选中任何树节点
  if (!nodeList || nodeList.length === 0) {
    return [];
  }
  let tempMap = new Map();
  nodeList.map(item => {
    // key:pid value:相同pid的节点数组
    if (!tempMap.get(item.pid)) {
      let tempList = [];
      tempList.push(item);
      tempMap.set(item.pid, tempList);
    } else {
      let tempList = tempMap.get(item.pid);
      tempList.push(item);
    }
  });
  tempMap.forEach((value) => {
    let tempList = value;
    tempList.map(item => {
      let findList = tempMap.get(item.id);
      if (findList) item.children = findList;
    });
  });
  let resultJson = {};
  for (let currentType of keyArr) {
    let arr = tempMap.get("_materialtype_" + currentType);
    if (arr) {
      resultJson[currentType] = arr;
    } else {
      resultJson[currentType] = [];
    }
  }
  return resultJson;
}

/** 
 * 根据type返回对应的修改语句
 */
const getUpdateUrl = (currentType) => {
  let url = "";
  if (currentType === '0') { // 视频
    url = 'material/updateVideo';
  } else if (currentType === '1') { // 图片
    url = 'material/updatePicture';
  } else if (currentType === '2') { // 音乐
    url = 'material/updateMusic';
  } else if (currentType === '7') { // 网页
    url = 'material/updateWeb';
  } else if (currentType === '14') { // 流媒体
    url = 'material/updateLive';
  } else if (currentType === '18') { // RSS
    url = 'material/updateRss';
  } else if (currentType === '15') { // Word
    url = 'material/updateWord';
  } else if (currentType === '16') { // Excel
    url = 'material/updateExcel';
  } else if (currentType === '17') { // PPT
    url = 'material/updatePPT';
  } else if (currentType === '35') { // PDF
    url = 'material/updatePDF';
  }
  return url;
}

/**
 * 素材名对象组成的Map
 * 
 * key 素材类型type
 * value {title, icon}
 */
const materialTitleObjMap = new Map();
materialTitleObjMap.set('0', { title: window.language['video.title'], treeIcon: 'material-video-o'});
materialTitleObjMap.set('1', { title: window.language['pic.title'], treeIcon: 'material-picture-o'});
materialTitleObjMap.set('2', { title: window.language['music.title'], treeIcon: 'material-music-o'});
materialTitleObjMap.set('7', { title: window.language['live.webUrl'], treeIcon: 'material-web-o'});
materialTitleObjMap.set('18', { title: window.language['rss.title'], treeIcon: 'material-rss-o'});
materialTitleObjMap.set('15', { title: window.language['word.title'], treeIcon: 'material-word-o'});
materialTitleObjMap.set('16', { title: window.language['excel.title'], treeIcon: 'material-excel-o'});
materialTitleObjMap.set('17', { title: window.language['ppt.title'], treeIcon: 'material-ppt-o'});
materialTitleObjMap.set('35', { title: window.language['pdf.title'], treeIcon: 'material-pdf-o'});

/** 
 * 根据type返回对应的下载语句
 */
const getDownloadUrl = (currentType) => {
  let url = "";
  if (currentType === '0') { // 视频
    url = 'material/downloadVideo';
  } else if (currentType === '1') { // 图片
    url = 'material/downloadPicture';
  } else if (currentType === '2') { // 音乐
    url = 'material/downloadMusic';
  } else if (currentType === '15') { // Word
    url = 'material/downloadWord';
  } else if (currentType === '16') { // Excel
    url = 'material/downloadExcel';
  } else if (currentType === '17') { // PPT
    url = 'material/downloadPPT';
  } else if (currentType === '35') { // PDF
    url = 'material/downloadPDF';
  }
  return url;
}

/** 
 * 获取下一个/上一个预览的素材
 * nextPre 0:前一张 1: 下一张
 * previewRows 显示的所有素材集合
 * checkObj 当前显示的素材
 */
const getShowPreviewObj = (nextPre, previewRows, checkObj) => {
  if (!previewRows || previewRows.length <= 0) {
    return null;
  }
  if (!checkObj || !checkObj.id) {
    return null;
  }
  let index = previewRows.findIndex(item => item.id === checkObj.id);
  if (index === -1) {
    return null;
  }
  let start = 0;
  let end = previewRows.length - 1;
  if (nextPre === 0) {
    if (index === start) {
      index = end;
    } else {
      index--;
    }
  } else {
    if (index === end) {
      index = start;
    } else {
      index++;
    }
  }
  return previewRows[index];
}

export { getUserFolderId, getUserOrgId, createTreeNodes, getUpdateUrl, getDownloadUrl, getShowPreviewObj, materialTitleObjMap }


// WEBPACK FOOTER //
// ./src/routes/Material/Util/components/materialUtil.js